import { Modal, Image } from "@mantine/core";
import { useState } from "react";

interface Props {
  videoUrl: string;
}

const VideoPlayerModal = ({ videoUrl }: Props) => {
  const [opened, setOpened] = useState(false);

  // Extract YouTube video ID
  const videoId = videoUrl.includes("watch?v=")
    ? videoUrl.split("watch?v=")[1].split("&")[0]
    : videoUrl.split("embed/")[1]?.split("?")[0];

  const embedUrl = `https://www.youtube.com/embed/${videoId}`;
  const thumbnailUrl = `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;

  return (
    <>
      <Image
        src={thumbnailUrl}
        alt="Video thumbnail"
        style={{ cursor: "pointer", borderRadius: "8px" }}
        onClick={() => setOpened(true)}
        width={300}
        height={270}
      />
      <Modal opened={opened} onClose={() => setOpened(false)} title="Campaign Video">
        <iframe
          width="100%"
          height="400"
          src={`${embedUrl}?autoplay=1&mute=0`}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </Modal>
    </>
  );
};

export default VideoPlayerModal;
